export default __webpack_public_path__ + "static/media/TO.b151d568.ico";